// Join truthy class-name fragments into one string. Internal helper so each
// component can merge its base classes with an optional `class` prop without
// repeating filter/join boilerplate. Not part of the public surface.
export function cx(...parts: ReadonlyArray<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
